import { PropsWithChildren } from "react"
import TopMenu from "./partials/TopMenu"
import SideMenu from "./partials/side-menu/SideMenu"
import "../../../pages/MainLayout.scss"

function Dashboard(props: PropsWithChildren) {
  return (
    <div className="w-screen">
      <div>
        <TopMenu />
        <div className="dashboard-grid">
          <section className="side-menu-show">
            <SideMenu />
          </section>
          <section className="dashboard-section">
            {props.children}
          </section>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
